const API_BASE = process.env.VUE_APP_API_ROOT;
export default {
  LOGIN: API_BASE + "/users/login",
  USERS: API_BASE + "/users",
  USER: API_BASE + "/user",
  USER_TRANSACTIONS: API_BASE + "/user/transactions",
  PASSWORD: API_BASE + "/users/password",
  INSTANCE_ID: API_BASE + "/instance/{id}",
  REFUND: API_BASE + "/refund",
  REFUNDS: API_BASE + "/refunds",
  TOPUP_PAYLANDS: API_BASE + "/topup/paylands",
  TOPUP_MIT: API_BASE + "/topup/mit",
  TOPUP_PAYLANDS_CARDS: API_BASE + "/topup/paylands/cards",
  TOPUP_PAYLANDS_CARDS_ID: API_BASE + "/topup/paylands/cards/{id}",
  TOPUP_MERCADOPAGO: API_BASE + "/topup/mercadopago",
  CATEGORY_UPGRADE: API_BASE + "/user/category/upgrade",
  USER_UPDATE: API_BASE + "/user/update",
};
